import React from 'react';
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from 'recharts';

import styles from './index.module.scss';

const BarChartDaily = (props) => (
    <BarChart className={styles.BarChartDaily} width={730} height={250} data={props.data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="total" fill="#8884d8" />
    </BarChart>
);

export default BarChartDaily;